import React from "react";
import colors from "../../utils/colors";
import { back, forward } from "../../assets";

const HearFromTeam = () => {
  const testimonials = [
    {
      quote:
        "This is the best thing for any doctor. I enjoy doing my job so much more. Such a game changer.",
      author: "Dr Aderemi",
    },
    {
      quote:
        "A fantastic platform that simplifies patient management. Highly recommended!",
      author: "D Kuku",
    },
    {
      quote:
        "Ubimed has transformed how I handle records. It's intuitive and efficient.",
      author: "Dr Aderemi",
    },
  ];

  return (
    <div
      className="flex flex-col px-4 sm:px-8 md:px-12 lg:px-[7.5rem] py-10 sm:py-12 md:py-[5rem] gap-10 sm:gap-12 md:gap-[5rem]"
      style={{ background: colors.dark }}
    >
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
        <div
          style={{ color: colors.primary }}
          className="font-lexend text-2xl sm:text-3xl md:text-[2.5rem] font-semibold text-center sm:text-left"
        >
          Hear from our team (Platform temporarily paused for upgrade please!)
        </div>
        <div className="flex gap-3 sm:gap-[1.25rem]">
          <img
            src={back}
            className="h-6 w-6 sm:h-8 sm:w-8 md:h-[2.5rem] md:w-[2.5rem] cursor-pointer"
            alt="Previous testimonial"
          />
          <img
            src={forward}
            className="h-6 w-6 sm:h-8 sm:w-8 md:h-[2.5rem] md:w-[2.5rem] cursor-pointer"
            alt="Next testimonial"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-[1.25rem]">
        {testimonials.map((testimonial, index) => (
          <div
            key={index}
            style={{ background: "#222222" }}
            className="flex flex-col gap-6 sm:gap-[2.38rem] rounded-xl sm:rounded-[1.25rem] p-4 sm:p-[1.25rem]"
          >
            <div className="py-2 sm:py-[0.62rem] font-lato text-base sm:text-[1.25rem] font-normal text-white">
              {testimonial.quote}
            </div>
            <div className="font-lato text-sm sm:text-[1.25rem] font-normal text-white">
              {testimonial.author}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HearFromTeam;
